import { AbstractListModel } from '@libs/factory/abstract-list/abstract-list.model';
import { marker } from '@colsen1991/ngx-translate-extract-marker';


export enum B2bProgramRate {
    FixSum = 1,
    Percent = 2,
}

export const b2bProgramRateList: AbstractListModel[] = [
    {
        id: B2bProgramRate.FixSum,
        title: marker('global.labels.fixSum'),
    },
    {
        id:  B2bProgramRate.Percent,
        title: marker('global.labels.percent'),
    },
];
